const toastOpt = {
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  icon: "info",
};

export default toastOpt;
